import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './servicesInfoCompany.scss';

const ServicesInfoCompany = () => {
    const { t } = useTranslation();
    const lineRefs = useRef([]);
    const parRefs = useRef([]);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px 0px 0px'
        };

        const lineObservers = lineRefs.current.map((lineRef) => {
            if (!lineRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('content__title-line--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(lineRef);
            return observer;
        });

        const parObservers = parRefs.current.map((parRef) => {
            if (!parRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('services-info__text--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(parRef);
            return observer;
        });

        return () => {
            lineObservers.forEach(obs => obs?.disconnect());
            parObservers.forEach(obs => obs?.disconnect());
        };
    }, []);

    return (
        <div className="services-info">

            <section className="services-info__section">
                <div className="services-info__content">
                    <h1 className="services-info__title content__title-backgroundWhite">{t('services.company.title')}</h1>
                    <div
                        ref={el => lineRefs.current[0] = el}
                        className="content__title-line"
                    />
                    <div
                        ref={el => parRefs.current[0] = el}
                        className="services-info__text services-info__text--hidden"
                    >
                        <p className='services-info__text-paragraph content__text-title-backgroundWhite'>
                            {t('services.company.p1')}
                        </p>
                        <p className='services-info__text-paragraph content__text-title-backgroundWhite'>
                            {t('services.company.p2')}
                        </p>
                        <p className='services-info__text-paragraph content__text-title-backgroundWhite'>
                            {t('services.company.p3')}
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ServicesInfoCompany;